import React from 'react';
import './Chat.css';
import './transitions.css';

const NotFound = () => {
  return (
    <div className="chat-app chat-anim-fade">
      <div className="chat-shell">
        <header className="chat-header">
          <div className="chat-header-identity">
            <div className="chat-header-text">
              <span className="chat-header-title">Webchat</span>
              <span className="chat-header-subtitle">Page not found</span>
            </div>
          </div>
        </header>
        <div className="chat-thread">
          <div className="chat-empty chat-anim-rise">
            <div className="chat-empty-title">Page not found</div>
            <p className="chat-empty-copy">
              We couldn&apos;t find the page you&apos;re looking for. Check that
              you&apos;re on a valid channel link.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
